import { Box, Button, Card, CardContent, Grid, Tab, Tabs, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import HTMLRenderer from 'react-html-renderer'
import theme from "../../utils/theme";
import ApiService from "../../api_service/api_service";
import TextHelper from "../../core/remove_tags";
import { Link } from "react-router-dom";


const TechReviews = (props) => {
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [value, setValue] = React.useState(0);
    const [blogs, setBlogs] = React.useState([]);
    const [vlogs, setVlogs] = React.useState([]);

    React.useEffect(() => {

        const getArticles = async () => {
            let responseVlog = await ApiService.getVlogs();
            console.log(responseVlog)
            setVlogs(responseVlog.data.docs);
            let responseBlog = await ApiService.getBlogs();
            console.log(responseBlog);
            setBlogs(responseBlog.data.docs);
        };

        getArticles();
    }, [value]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    return (
        <Box>
            <Typography sx={{
                fontSize: theme.palette.Title.fontSize,
                fontWeight: 'bold'
            }}>Tech Reviews</Typography>
            <Box
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            >
                <Tabs value={value} onChange={handleChange}>
                    <Tab label="Video Contents" sx={{
                        fontWeight: 'bold',
                        px: '0px'
                    }} />
                    <Tab label="Articles Contents" sx={{
                        fontWeight: 'bold',
                        px: '0px',
                        ml: '20px'
                    }} />
                </Tabs>
                <Link to={`/tech-reviews`} style={{ textDecoration: 'none' }}>
                    <Typography sx={{ fontSize: '16px', fontWeight: '500', color: '#EC1D25' }}>SEE ALL</Typography>
                </Link>
            </Box>
            {value === 0 ?
                <Grid container spacing={2.5} mt={3}>
                    {vlogs.map((article, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>

                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: '12px',
                                    bgcolor: '#ffffff',
                                    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.06)',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        transform: 'translateY(-4px)',
                                        boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
                                    },
                                }}
                            >
                                { }


                                <Box
                                    sx={{
                                        height: 150,
                                        backgroundColor: '#0a0a0a',
                                        borderRadius: '10px 10px 0 0',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative',
                                        overflow: 'hidden',
                                    }}
                                    
                                >
                                    <iframe
                                        src={article.url}
                                        frameBorder="0"
                                        width={isSmallScreen ? "120" : "265"}
                                        height={isSmallScreen ? "120" : "200"}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        title="Content"
                                    />


                                    <Typography
                                        variant="caption"
                                        sx={{
                                            color: '#ffffff',
                                            fontSize: '0.72rem',
                                            fontWeight: 600,
                                            position: 'absolute',
                                            bottom: 8,
                                            zIndex: 2,
                                            letterSpacing: '0.3px',
                                        }}
                                    >
                                        {article.tag}
                                    </Typography>

                                </Box>


                                { }
                                <CardContent sx={{ p: 2, flexGrow: 1 }}>
                                    <Typography
                                        variant="h6"
                                        component="h3"
                                        sx={{
                                            fontWeight: 700,
                                            color: '#333333',
                                            fontSize: '0.98rem',
                                            mb: 0.8,
                                        }}
                                    >
                                        {article.title}
                                    </Typography>

                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: '#8e8e93',
                                            fontSize: '0.82rem',
                                            lineHeight: 1.45,
                                            display: '-webkit-box',
                                            WebkitLineClamp: 3,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <HTMLRenderer html={TextHelper.makeReadMore(article.body)} />
                                    </Typography>
                                </CardContent>
                            </Card>

                        </Grid>
                    ))}
                </Grid>
                : blogs.map((article, index) => (
                    <Link key={index} to={`/review-detail?content=Read&id=${article._id}`} style={{ textDecoration: 'none' }}>
                        <Card key={index} sx={{ display: 'flex', mt: '20px', height: '120', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)' }}>

                            <Box
                                component="img"
                                sx={{
                                    overflow: 'hidden',
                                }}
                                src={ApiService.basedPublicURL + article.image}
                                style={{
                                    width: isSmallScreen ? "500px" : '300px',
                                    height: isSmallScreen ? '120px' : '200px',
                                }}
                            />

                            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', p: '10px' }}>
                                <Typography sx={{ fontSize: isSmallScreen ? theme.palette.mobileTitle.fontSize : theme.palette.SubTitle.fontSize, fontWeight: 'bold' }}>
                                    {article.title}
                                </Typography>
                                <Box height='10px' />
                                <Typography sx={{ fontSize: isSmallScreen ? theme.palette.mobileContent.fontSize : theme.palette.Content.fontSize }}>
                                    <HTMLRenderer html={TextHelper.makeReadMore(article.body)} />
                                    <span>
                                        <Button sx={{ ml: '50px', color: 'blue', fontSize: isSmallScreen ? theme.palette.mobileContent.fontSize : theme.palette.Content.fontSize }} component={Link} to={`/review-detail?content=Read&id=${article._id}`}>
                                            Read more...
                                        </Button>
                                    </span>
                                </Typography>
                            </Box>
                        </Card>
                    </Link>
                ))}
        </Box>
    )
}

export default TechReviews